export default "__VITE_ASSET__Bh0k3xUg__"